import { namespace as createVuexClass } from 'vuex-class';

export const namespace = 'metrics';
export const store = createVuexClass(namespace);

export const FETCH_DEVICE_STATUS = 'fetchDeviceStatus';
export const FETCH_DEVICE_COUNT = 'fetchDeviceCount';
export const UPDATE_DEVICE_STATUS_STATE = 'updateDeviceStatusState';
export const UPDATE_DEVICE_COUNT_STATE = 'updateDeviceStatusState';
export const SET_ERROR = 'setError';

export interface IDeviceStatusItem {
    status: string;
    count: number;
}

export interface IDeviceCountBucket {
    label: string;
    value: number;
}

export interface IDeviceCount {
    startDate: string;
    endDate: string;
    buckets: IDeviceCountBucket[];
}

export interface MetricsState {
    errorMessage: string;
}
